import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Row, Col, Image } from 'react-bootstrap'
import { moreIcon } from '../../assets'

export default function SustainabilitySection() {
    return (
        <Row className='sustainability-section mx-0'>
            <Col sm={12} md={6}>
                {/* <AnimationOnScroll duration={2} animateIn="animate__slideInUp" className='solid-rectangle'>
                </AnimationOnScroll> */}
            </Col>
            <Col sm={12} md={6} className='d-flex flex-column justify-content-center mt-4 mt-md-0'>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                    <p align='left' style={{ fontWeight: '500', fontSize: '1.5em' }}>ENVIRONMENT SUSTAINABILITY</p>
                </AnimationOnScroll>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                    <h3 style={{ fontWeight: '800', fontSize: '2em', color: '#122E31', textAlign: 'start' }}>Giving back to <br />the nature</h3>
                </AnimationOnScroll>
                <AnimationOnScroll duration={2}  animateIn="animate__slideInUp">
                    <p align='left' style={{ fontWeight: '500', fontSize: '1.5em' }}>
                        We are dedicated to building a sustainable future for our<br />
                        planet and global economy, which is why we believe<br />
                        that everyone should look for solutions that consume<br />
                        less resources or use it more efficiently.
                    </p>
                </AnimationOnScroll>
                <AnimationOnScroll duration={2}  animateIn="animate__slideInUp" className='learn-more-button d-flex align-items-center'>
                    LEARN MORE
                    <Image src={moreIcon} className='mx-3' />
                </AnimationOnScroll>
            </Col>
        </Row>
    )
}
